export default __webpack_public_path__ + "static/media/gameplay_tips_content.bf65c696.png";